import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ElasticSearchService } from '../shared/search-elasticsearch.service';
import { UtilsService } from '../shared/utils.service';
//<span *ngIf="utils.isInEsFilters(esFilters, agg.key, term.key)">{{term.key}}</span>
@Component({
  selector: 'search-facets',
  template: require('./partials/search-facets.html')
})
export class SearchFacetsComponent implements OnInit {

  @Input() esAggregations: Object[];
  @Input() fields: string[];
  @Input() esFilters: Object[];
  @Input() labels: any;
  @Input() language: string;
  @Output() onFilter: EventEmitter<Object> = new EventEmitter<Object>();
  @Input() target: string;

  private filterQueryParams: string;
  private searchQueryParams: string;
  private newQueryParams: any;
  //types = ['type','composer','soloist','conductor','instrument'];

  constructor(private utils: UtilsService, private route: ActivatedRoute, private router: Router, private es: ElasticSearchService) {}

  ngOnInit(){
    this.route.queryParams.subscribe(params => {
      this.searchQueryParams = params['s'];
      this.filterQueryParams = params['f'];
    });
    this.route.params.subscribe(params => {
      // Entry fields
      if(params['field'] && params['value'])
        this.filterQueryParams = this.utils.appendQueryParam(this.filterQueryParams, params['field'], params['value']);
    });
  }

  onSelect(type: string, value: string) {
    // Callback 
    this.onFilter.emit({type: type, value: value});
    // Nav
    let newQueryParams = { queryParams: {} };
    // Current filters/search
    if(this.searchQueryParams)
      newQueryParams.queryParams['s'] = this.searchQueryParams;
    newQueryParams.queryParams['f'] = this.utils.appendQueryParam(this.filterQueryParams, type, value);
    // go
    if(this.target)
      this.router.navigate([this.language+'/'+this.target], newQueryParams);
    else {
      newQueryParams['relativeTo'] = this.route;
      this.router.navigate(['.'], this.newQueryParams);
    }
  }



}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/search-facets.component.ts